import { REDIRECTED } from "../actions/types";

export default (alert = false, action) => {
  if (action.type === REDIRECTED) {
    return action.payload;
  }
  return alert;
};
